import { Search as SearchIcon } from "@carbon/icons-react";
import { useTranslation } from "react-i18next";

type SearchProps = {
  value: string;
  handleSearch: (e: React.ChangeEvent<HTMLInputElement>) => void;
  label?: string;
};

const Search = ({ value, handleSearch, label = "cta.search" }: SearchProps) => {
  const { t } = useTranslation();
  return (
    <div className="w-full flex-1 relative">
      <div className="relative text-gray-400 focus-within:text-gray-500">
        <label htmlFor="desktop-search" className="sr-only">
          {t(label)}
        </label>
        <input
          onChange={handleSearch}
          id="desktop-search"
          type="search"
          placeholder={t(label)}
          value={value}
          className="block text-sm w-full pl-12 placeholder-gray-500 focus:ring-0 border-0 shadow rounded-2xl"
        />
        <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center justify-center pl-4">
          <SearchIcon size={20} aria-hidden="true" />
        </div>
      </div>
    </div>
  );
};

export default Search;
